export enum EWeights {
  'Ruim' = 1,
  'Regular',
  'Bom',
  'Ótimo',
}
